import type { ResponsiveOptions } from './types'
import type { SpanTypes } from './style/types'
import { twRowSpan } from './style/rowSpan'

/**
 * This is a function which can take either an object
 * or a number and return a string with correct css classnames.
 *
 * @param {object | number} spanOptions - A object param
 * @return {string} A string with correct css classnames
 *
 * @example
 * getRowSpanClasses(2)
 * // => 'ds-row-span-2'
 *
 */
export const getRowSpanClasses = (
  spanOptions: SpanTypes | ResponsiveOptions | number
) => {
  switch (typeof spanOptions) {
    case 'number': {
      return (
        twRowSpan.sm && twRowSpan.sm[spanOptions as keyof typeof twRowSpan.sm]
      )
    }
    case 'object': {
      const spanClasses = new Array<string>()
      Object.keys(spanOptions).forEach((key) => {
        const selectedSize = { ...twRowSpan[key as keyof typeof twRowSpan] }
        const selectedValue = spanOptions[key as keyof typeof spanOptions]
        const selectedOption =
          selectedSize[selectedValue as keyof typeof selectedSize]
        selectedOption && spanClasses.push(selectedOption as string)
      })
      return spanClasses.filter(Boolean).join(' ')
    }
    default:
      return 'default'
  }
}
